import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, FormControl, Tooltip, Skeleton, Grid, Card, CardContent, LinearProgress, Chip, Autocomplete, TextField, Popper } from '@mui/material';
import Highcharts, { color } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ChartLine, Activity, ChartBar, ChartNoAxesCombined, ChartColumnIncreasing, ChartPie, ChartSpline, TrendingDown, TrendingUp } from 'lucide-react'
import { Col, Divider, message, Row } from 'antd';
import { DataGrid } from '@mui/x-data-grid';
import HighPieChart from "../../../components/Graphs/HighChartPie"
import { colors } from './colors';
import axios from 'axios';
import { HelpCenterOutlined, HelpOutline } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';


export const SkewnessKurtosisGraph = ({ column, histogramData, loading }) => {


    const GenerateChart = () => {
        Highcharts.chart('container', {
            chart: {
                zoomType: 'xy',
                backgroundColor: 'transparent',
                width:'820'

            },
            title: {
                text: 'Histogram and KDE Curve of ' + column
            },
            credits:{
                text:''
            },
            xAxis: [{
                title: { text: column },
                crosshair: true
            }],
            yAxis: [{ // Left Y-axis for Histogram
                title: { text: 'Frequency (Histogram)' },
                opposite: false
            }, { // Right Y-axis for KDE
                title: { text: 'Density (KDE)' },
                opposite: true
            }],
            tooltip: {
                shared: true
            },
            legend: {
                itemStyle: {
                color: 'var(--textPrimary)',   // <-- legend text color
                fontWeight: 'bold',            // optional
                fontSize: '14px'               // optional
                },
                itemHoverStyle: {
                color: '#fffb00ff'           // <-- color when hovering legend item
                }
            },
            series: [
                {
                type: 'column',
                name: 'Histogram',
                data: histogramData.histogram.map(item=>[item.x, item.y]),
                yAxis: 0,
                color: '#7cb5ec',
                pointWidth: 25,
                tooltip: {
                    valueSuffix: ' count'
                }},
                {
                type: 'spline',
                name: 'KDE Curve',
                data: histogramData.distribution.map(item=>[item.x, item.y]),
                yAxis: 1,
                color: '#ff4d4f',
                lineWidth: 2,
                tooltip: {
                    valueSuffix: ' density'
                }
                }
            ]
            });
    }
    
    useEffect(() => {
        if (!loading && histogramData) {
            GenerateChart();            
        }
    }, [loading, histogramData]);

    return(
        <>
            {
            !loading?
                <div id="container"></div>
            :
                <Skeleton height={400} />
            }
        </>
    )

}


export const OutlierGraph = ({ chartData, loading }) => {
    
    // const { column, bins, counts, outlier_bins, outliers } = chartData;
    const { column, bins, counts, lower_bound, upper_bound, outlier_bins, outliers } = chartData;

    const GenerateChart = () => {
        Highcharts.chart('outlier_container', {
            chart: { type: "column", backgroundColor: 'transparent' },
            title: { text: `Histogram with Outliers (${column})` },
            xAxis: {
                title: { text: column },
            },
            yAxis:{
                title: { text: "Frequency" },
            },
            credits:{
                text:''
            },
            tooltip: {
                formatter: function () {          
                // For Data Distribution
                const series = this.series;
                const points = series.points;
                const i = points.indexOf(this.point);

                let binWidth;
                if (points[i + 1]) {
                    binWidth = points[i + 1].x - this.point.x;
                } else if (points[i - 1]) {
                    binWidth = this.point.x - points[i - 1].x;
                } else {
                    binWidth = 10;
                }

                const from = (this.point.x - binWidth / 2).toFixed(0);
                const to = (this.point.x + binWidth / 2).toFixed(0);
                // Check if this is an outlier point
                if (this.series.name === "Outliers") {
                    return `<b>${this.point.x}</b><br/>Outlier count: ${this.point.y}`;
                }
                return `<b>${from} - ${to}</b><br/>Data points count: ${this.point.y}`;
                },
            },
            legend: {
                itemStyle: {
                color: 'var(--textPrimary)',   // <-- legend text color
                fontWeight: 'bold',            // optional
                fontSize: '14px'               // optional
                },
                itemHoverStyle: {
                color: '#fffb00ff'               // <-- color when hovering legend item
                }
            },
            series: [
                {
                    name: "Data Distribution",
                    data: counts.map((count, i) => [bins[i], count]),
                    color: "#87CEEB",
                    tooltip: { pointFormat: "Count: {point.y}" },
                    dataLabels: {
                            format: '{point.name}',
                            style: {
                                textOutline: 'none',
                                color: 'var(--textPrimary)'
                            }
                        },
                    },
                {
                    name: "Outliers",
                    type: "column",
                    data: outliers.map((value, i) => [outlier_bins[i], value]), // Use outlier_bins for x-position and outliers for height
                    color: "#FF0000",
                    tooltip: { pointFormat: "Outlier: {point.y}" },
                },
                {
                    name: "Bounds",
                    type: "line",
                    color: "orange",
                    data: [
                        [lower_bound, 0],
                        [lower_bound, Math.max(...counts)],
                        [upper_bound, 0],
                        [upper_bound, Math.max(...counts)],
                    ],
                    lineWidth: 2,
                    dashStyle: "Dash",
                    enableMouseTracking: false,
                    marker: { enabled: false },
                },
                ],
        });
    }
    
    useEffect(() => {
        if (!loading && chartData) {
            GenerateChart();
        }
    }, [loading, chartData]);  

    return(
        <>
            <div id="outlier_container"></div>
        </>
    )
}